import * as React from "react";
import FittedImage from "react-fitted-img";
import Helmet from "react-helmet";
import AboutUsBannerMobile from "../../assets/images/TUSA-aboutus-corevalues-hero-mobile.jpg";
import AboutUsBanner from "../../assets/images/TUSA-aboutus-corevalues-hero-1440x550.jpg";
import Button from "../../components/Button/Button";
import StaticBanner from "../../components/StaticBanner/index";
import { Config } from "../../config/index";
import { AppContext } from "../../Context";
import { ComponentTheme } from "../../definitions/components";
import { IRootState } from "../../definitions/root";
import "./AboutUs.css";
import values from "./AboutUsData";

const MemberImage = ({ title, src }) => (
  <FittedImage
    className="member-img"
    decoding="async"
    fit="cover"
    src={src}
    srcSet={`${src} 240w`}
    sizes="
      (min-width: 320px) 300px,
      (min-width: 768px) 320px,
      (min-width: 1024px) 360px,
      (min-width: 1200px) 420px
    "
    alt={`Our Team - ${title}`}
  />
);

export default function AboutUsPageRender() {

  const hoverHandler = (ev) => {
    ev.currentTarget.querySelector('.member-img').style.filter = "brightness(70%)";
  };

  const leaveHandler = (ev) => {
    ev.currentTarget.querySelector('.member-img').style.filter = "brightness(100%)";
  };

  return (
    <AppContext.Consumer>
      {({ app: { isMobile, isTablet } }: IRootState) => {
        const AboutUsBannerImage = !!isMobile || !!isTablet ? AboutUsBannerMobile : AboutUsBanner;
        return (
          <React.Fragment>
            <Helmet>
              <title>About Us | Tabacalera USA</title>
              <link rel="canonical" href={`${Config.FRONT_END_URL}/aboutus`} />
              <meta name="description" content={"Our Team"} />
            </Helmet>
            <div className="page page--about">
              <StaticBanner
                title={"About Us"}
                bannerImg={{
                  fit: "cover",
                  src: AboutUsBannerImage,
                }}
              />

              <div className="member member-spotlight">
                <div className="container">
                  <div className="row center-xs">
                    <div className="col-sm-8 center-sm">
                      <div className="member-details">

                        <div className="heading">
                          <p className="name">Our Mission and Values</p>
                        </div>

                        <p className="bio">
                          We enrich our historical legacy by responsibly developing exclusive brands for people who choose to experience special moments.
                        </p>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mission-container">
                <div className="about-content">
                  <div className="members">
                    <div className="row">
                      {values.map(({ title, overlay, image }, i) =>
                        <div key={i} className="member col-xs-12 col-sm-6 col-lg-4" onMouseOver={hoverHandler} onMouseLeave={leaveHandler}>
                          <MemberImage title={title} src={image} />
                          <div className="values" >
                            <p className="value">{title}</p>
                            <p className="overl">{overlay}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}



// WEBPACK FOOTER //
// ./src/containers/AboutUs/render.tsx